function infoContentOffset() {
	const sections = document.querySelectorAll('.section--info')
	if (!sections.length) return

	const update = (section) => {
		const content = section.querySelector('.section--info_content')
		const inner = section.querySelector('.inner')
		if (!content || !inner) return

		const contentTop = parseFloat(getComputedStyle(content).top) || 0
		const offset = content.offsetHeight + contentTop * 1.5 - inner.offsetHeight
		section.style.marginBottom = offset > 0 ? offset + 'px' : ''
	}

	sections.forEach((section) => {
		update(section)
		new ResizeObserver(() => update(section)).observe(section)
	})
}

export { infoContentOffset }
